import { IconButton, MenuItem, Typography } from '@mui/material';
import Menu from '@mui/material/Menu';
import type { GetLightInvoicesResponse } from '@weft/api-definition';
import { VyIcon } from '@weft/icons';
import { getPrimaryContact } from '@weft/services';
import { isEmptyArray, isNotEmptyArray, isNullOrUndefined, type ItemOf } from '@weft/utils';
import React from 'react';
import { useMenu } from '../../../../hooks/use-menu';
import { ShareInvoicesDialog } from '../../invoices-components/share-invoices-dialog/ShareInvoicesDialog';

type LightInvoiceViewPageShareMenuProps = {
  invoiceData: ItemOf<GetLightInvoicesResponse['invoices']>
};

export const LightInvoiceViewPageShareMenu: React.FC<LightInvoiceViewPageShareMenuProps> = ({ invoiceData }) => {
  const { isOpen, handleMenuOpen, handleMenuClose, anchorElement } = useMenu();

  return (
    <>
      <IconButton onClick={handleMenuOpen}>
        <VyIcon
          icon="Share"
          color="#323232"
        />
      </IconButton>

      <Menu
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={isOpen}
        anchorEl={anchorElement}
        onClose={handleMenuClose}
        MenuListProps={{
          className: 'py-2',
        }}
        slotProps={{
          paper: {
            className: 'mt-2 max-w-[250px] w-full rounded-lg',
          },
        }}
      >
        <ShareInvoicesDialog invoicesData={[{ 
          invoiceId: invoiceData.id,
          customerName: invoiceData.customer.name,
          contactEmail: isNotEmptyArray(invoiceData.customer.contacts) ? getPrimaryContact(invoiceData.customer.contacts).email : '---',
          issueDate: invoiceData.billingCycle.startTime,
          amount: invoiceData.revenueBreakdown.total,
          currency: invoiceData.currency,
        }]}
        >
          <MenuItem
            disabled={isNullOrUndefined(invoiceData.customer.contacts) || isEmptyArray(invoiceData.customer.contacts)}
            className='pl-4'
          >
            <Typography>Share via email</Typography>
          </MenuItem>
        </ShareInvoicesDialog>
      </Menu>
    </>
  );
};